import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

const renderFatalError = () => {
  rootElement.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#050505;color:#f7f7f7;font-family:sans-serif;padding:24px;text-align:center;">
      <div>
        <h1 style="font-size:24px;margin-bottom:12px;">App Misconfigured</h1>
        <p style="font-size:14px;opacity:0.8;">Missing required configuration. The app cannot start.</p>
      </div>
    </div>
  `;
};

const start = async () => {
  try {
    renderApp();
  } catch (error) {
    console.error(error);
    renderFatalError();
  }
};

start();
